export const WHITE_LIST_DOMAINS = [
  'witro.shop',
  'witrodev.ir',
  'witrostage.ir',
  'localhost:3000',
  'localhost',
];

export const isWitroPlatformDomain = (domain: string): boolean =>
  WHITE_LIST_DOMAINS.includes(domain.toLowerCase());
